<!-- 1模板:html结构 -->
<template>
  <div id="home">
    <app-header v-on:titleChanged="updatetitle($event)" v-bind:title1="title1"></app-header>
    <users v-bind:users="users"></users>
    <users v-bind:users="users"></users>

    <app-footer v-bind:title1="title1"></app-footer>
  </div>
</template>

<!-- 2行为:逻辑处理 -->
<script>
  // 局部注册组件
  import Users from './Users'
  import Header from './Header'
  import Footer from './Footer'

  export default {
    name: 'home',
    data() {
      return {
        // title: "这是一个干净的脚手架项目!"
        users: [
          //   {name:"brownwang",position:"运维开发",show:false},
          //   {name:"brownwang",position:"运维开发",show:false},
          //   {name:"brownwang",position:"运维开发",show:false},
          //   {name:"brownwang",position:"运维开发",show:false}
        ],
        title1: "传递的是一个值 number string boolean"
      }
    },
    methods: {
      updatetitle(title) {
        this.title1 = title;
      }
    },

    components: {
      "users": Users,
      "app-header": Header,
      "app-footer": Footer
    },
    created() {
      this.$http.get("https://jsonplaceholder.typicode.com/users")
        .then((data) => {
          this.users=data.body;
        })
    }
  }
</script>

<!-- 3样式:解决样式 -->
<style scoped>
  h1 {
    color: purple;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue